import { OrderApiModel } from 'app/models/order-api.model';
import * as orderActions from '../actions/orders.actions';
import * as userActions from '@core/auth/@store/user/user.actions';
import { createReducer, on, Action } from '@ngrx/store';

export interface State {
  orders: OrderApiModel[];
  totalOrders: number;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  orders: [],
  totalOrders: 0,
  isLoading: false,
  isReady: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(orderActions.loadOrders, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(orderActions.loadOrdersSuccess, (state: State, { payload }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    orders: payload.results,
    totalOrders: payload.count,
  })),
  on(orderActions.createOrder, orderActions.editOrder, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    orderActions.createOrderSuccess,
    orderActions.createOrderFailed,
    orderActions.editOrderSuccess,
    orderActions.editOrderFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(userActions.setActiveCompany, (state: State) => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
